var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCalendar({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M19.543 0c.568 0 1.028.46 1.028 1.029v1.73A3.772 3.772 0 0124 6.513V20.23A3.771 3.771 0 0120.229 24H3.77A3.771 3.771 0 010 20.229V6.514a3.772 3.772 0 013.428-3.756v-1.73a1.029 1.029 0 112.058 0l-.001 1.714h5.486V1.029c0-.53.402-.967.917-1.023L12 0c.568 0 1.029.46 1.029 1.029l-.001 1.713h5.486V1.029c0-.53.401-.967.917-1.023zm2.399 10.971H2.057v9.258c0 .946.768 1.714 1.714 1.714H20.23c.946 0 1.714-.768 1.714-1.714l-.001-9.258zM11.984 4.8l-7.511-.001-.016.001h-.686c-.946 0-1.714.768-1.714 1.714v2.4h19.885v-2.4c0-.946-.767-1.714-1.713-1.714l-.671-.001-.015.001h-.016l-7.512-.001L12 4.8h-.016z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.23e511e9.svg";
export { ForwardRef as ReactComponent };